export default "__VITE_ASSET__uk1cfChZ__"